var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.996,
    height: 33.445,
    viewBox: "0 0 48.996 33.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "letter",
    d: "M43.163-5.582H5.833A5.835,5.835,0,0,0,0,.251V22.03a5.835,5.835,0,0,0,5.833,5.833h37.33A5.835,5.835,0,0,0,49,22.03V.251A5.835,5.835,0,0,0,43.163-5.582ZM5.833-3.249h37.33A3.514,3.514,0,0,1,46.6-.4L24.5,11.917,2.391-.4A3.514,3.514,0,0,1,5.833-3.249Zm37.33,28.768H5.833a3.51,3.51,0,0,1-3.5-3.5V2.234L23.926,14.273a1.229,1.229,0,0,0,.572.152,1.106,1.106,0,0,0,.572-.152L46.663,2.234V22.019A3.5,3.5,0,0,1,43.163,25.519Zm0,0",
    transform: "translate(0 5.582)",
    fill: "#d4af37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterActivity);
export default __webpack_public_path__ + "static/media/letterActivity.8cdbac7cf0cdf3e53ceb05e46c6b429a.svg";
export { ForwardRef as ReactComponent };